import { render, staticRenderFns } from "./ActivityMultiTextContainer.vue?vue&type=template&id=ef245cba&scoped=true"
import script from "./ActivityMultiTextContainer.vue?vue&type=script&lang=ts"
export * from "./ActivityMultiTextContainer.vue?vue&type=script&lang=ts"
import style0 from "./ActivityMultiTextContainer.vue?vue&type=style&index=0&id=ef245cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef245cba",
  null
  
)

/* custom blocks */
import block0 from "./ActivityMultiTextContainer.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports